import React from 'react';
import { useSelector } from 'react-redux';
import MainLogo from './MainLogo';
import MainNavLink from './MainNavLink';
import SearchAndCart from './SearchAndCart';

function MainNavBottomRow({
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  activePrimaryNav,
  globalSearchModalActive,
}) {
  const { isSearchActive } = useSelector((state) => state.search);

  return (
    <div className="main-nav-bottom-row hidden lg:flex justify-between items-center mt-16">
      <MainLogo
        isSearchActive={isSearchActive}
        globalSearchModalActive={globalSearchModalActive}
      />

      {/* nav link */}
      <MainNavLink
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        activePrimaryNav={activePrimaryNav}
      />

      {/* search and cart */}
      <SearchAndCart />
    </div>
  );
}

export default MainNavBottomRow;
